module.exports = __webpack_public_path__ + "static/media/splash.c2a52c93.png";